export const qnData = [
    {
        qn:"Do I have to pay up front?",
        answer:"To get a free 7 day membership pass, you must input your credit card information, but we will not charge you until you officially accept our membership invitation at the end of your 7-day free trial. Cancel anytime.",
        show: true
    },
    {
        qn:"How much does it cost?",
        answer:"Immerse’s membership is $45 per month - a fraction of the cost to travel abroad and wildly more effective than traditional language learning apps.",
        show: "false"
    },
    {
        qn:"What's included in my membership?",
        answer:"12 live, small-group lessons per month, plus unlimited hours to socialize with peers in our Social Lounge.",
        show: "false"
    },
    {
        qn:"What languages do you offer?",
        answer:`Spanish is our only immersive program available right now. To get notified whenwe launch new languages, sign up <strong>here</strong>.`,
        show: "false"
    },
    {
        qn:"Do I need a VR headset?",
        answer:"Yes. Immerse is live on the Meta Quest 2 VR headset. We plan to make our VR app cross platform (available on multiple VR devices) in the near future. If you do not own a Quest 2 VR headset, you can order one <strong>here</strong>.",
        show: "false"
    },
]